// * =================================================================================================================
// *                                              User Routes
// * =================================================================================================================
// POST
export const SIGNUP = "/v1/user/sign-up";
export const LOGIN = "/v1/user/sign-in";
export const FIND_USER = "/v1/user/find";
// GET
export const FIND_ME = "/v1/user/me";
// DEL
// PUT

// * =================================================================================================================
// *                                            Admin Routes
// * =================================================================================================================
// POST
// PUT
// DELETE

// * =================================================================================================================
// *                                            Municipality Routes
// * =================================================================================================================
// POST
export const FIND_MUNICIPALITY = "/v1/admin/municipality";
export const CREATE_MUNICIPALITY = "/v1/admin/municipality";
// PUT
export const UPDATE_MUNICIPALITY = "/v1/admin/municipality";
// DELETE
export const DELETE_MUNICIPALITY = "/v1/admin/municipality";

// * =================================================================================================================
// *                                          City & Province Routes
// * =================================================================================================================
// GET
export const FIND_PROVINCE_CITY = "v1/cities/provinces";
// * =================================================================================================================
// *                                               Company Routes
// * =================================================================================================================
// POST
export const CREATE_COMPANY = "/v1/admin/company";
// POST
export const UPDATE_PRICE = "/v1/company/update-price";
// PUT
export const UPDATE_COMPANY = "/v1/admin/company";

// DELETE
export const DELETE_COMPANY = "/v1/user";
// * =================================================================================================================
// *                                               Driver Routes
// * =================================================================================================================
// POST
export const FIND_DRIVER = "/v1/driver/find";
export const CREATE_DRIVER = "/v1/driver";
// PUT
export const UPDATE_DRIVER = "/v1/driver";
// DELETE
export const DELETE_DRIVER = "/v1/driver";
// * =================================================================================================================
// *                                               orders Routes
// * =================================================================================================================
// POST
export const FIND_ORDER = "/v1/order/find";
// PUT
// DELETE
// PATCH
export const UPDATE_ORDER = "/v1/order";
// * =================================================================================================================
// *                                               Client Routes
// * =================================================================================================================
// POST
// GET
export const FIND_CLIENT = "/v1/client";
// PUT
export const UPDATE_CLIENT = "/v1/client";
// DELETE
export const DELETE_CLIENT = "/v1/client";
// * =================================================================================================================
// *                                               category Routes
// * =================================================================================================================
// POST
export const CREATE_CATEGORY = "/v1/category";
// GET
export const FIND_CATEGORY = "/v1/category";
// PUT
export const UPDATE_CATEGORY = "/v1/category";
export const CATEGORY_PRICE_CATEGORY = "/v1/company/update-price";
// DELETE
export const DELETE_CATEGORY = "/v1/category";
// * =================================================================================================================
// *                                               work time Routes
// * =================================================================================================================
// POST
export const CREATE_WORK_TIME = "/v1/work-times";
// GET
export const FIND_WORK_TIME = "/v1/work-times";
// PUT
export const UPDATE_WORK_TIME = "/v1/work-times";
// DELETE
export const DELETE_WORK_TIME = "/v1/work-times";
// * =================================================================================================================
// *                                              Storage Routes
// * =================================================================================================================
// GET
export const GET_FILE = "/new-user/upload";
// POST
export const UPLOAD_FILE = "/v1/user/upload";
// * =================================================================================================================
// *                                              limited area
// * =================================================================================================================
// GET
export const FIND_AREA = "/v1/cities";
// POST
export const CREATE_AREA = "/v1/cities";
// delete
export const DELETE_AREA = "/v1/cities";
// put
export const UPDATE_AREA = "/v1/cities";
// * =================================================================================================================
// *                                              limited area
// * =================================================================================================================
// GET
export const FIND_TICKET = "/v1/ticket/";
// POST
export const CREATE_TICKET = "/v1/ticket";
export const REPLY_TICKET = "/v1/ticket/reply";
